import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { DatePipe } from '@angular/common';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-replace-employee-popup',
  templateUrl: './replace-employee-popup.component.html',
  styleUrls: ['./replace-employee-popup.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ReplaceEmployeePopupComponent implements OnInit {
  image: any;
  userForm: FormGroup = new FormGroup({});
  employeementRelatedUserForm: FormGroup = new FormGroup({});
  generalInformationUserForm: FormGroup = new FormGroup({});
  educationRelatedInformationUserForm: FormGroup = new FormGroup({});
  salaryRelatedInformationUserForm: FormGroup = new FormGroup({});
  priorEmploymentRelatedInformationUserForm: FormGroup = new FormGroup({});
  getAllEmployeeofCompany: any = [];
  loggedInUserCompanyID: any;
  loggedInUserCompanyName: any;
  getUserId:any=0;
  buttonColorName:any;
  isReplaceEmployeeFilled: boolean = false;
  assignReporteesDropdown:any = [];
  getListOfGroupNameOfComp: any = [];
  getListOfCompanyNameOfComp: any = [];
  getListOfBandNameOfComp: any = [];
  getListOfGradeNameOfComp: any = [];
  getListOfDesignationsOfComp: any = [];
  getListOfDepartmentsOfComp: any = [];
  getListOfSubDepartmentsOfComp: any = [];
  getListOfDesignationsAtDOJOfComp: any = [];
  getListOfCurrentRatingOfComp: any = [];
  getListOfLastYearRatingOfComp: any = [];
  getListOfLastToLastYearRatingOfComp: any = [];
  getCountryList: any = []
  getListOfHighestQualificationOfComp: any = [];
  getCurrencyList: any = [];
  getBankNameList: any = [];
  customFieldObject: any = [];
  currentDate:any
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService, private config: Config,
    public dialogRef: MatDialogRef<ReplaceEmployeePopupComponent>, private fb: FormBuilder,
    private encryptionService: EncryptionService,private datePipe: DatePipe, private loader:LoaderService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this. buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = this.data?.compId;
    this.getUserId = this.data?.userId;
    this.currentDate = (new Date()).toISOString();
    this.initilaizeUserForm();
    this.initilaizeEmployeeRelatedUserForm();
    this.initilaizeGeneralInformationUserForm();
    this.initilaizeEducationRelatedInformationUserForm();
    this.initilaizeSalaryRelatedInformationUserForm();
    this.initilaizePriorEmploymentRelatedInformationUserForm();
    this.getAllCustomFieldsList();
    this.getAllEmployeeDropdownByCompanyID();
    this.getGroupNameByCompany();
    this.getCompanyNameByCompany();
    this.getBandsByCompany();
    this.getGradeByCompany();
    this.getDesignationsByCompany();
    this.getDepartmentsByCompany();
    this.getSubDepartmentByCompany();
    this.getDesignationsAtDOJByCompany();
    this.getCurrentRatingByCompany();
    this.getLastYearRatingByCompany();
    this.getLastToLastYearRatingByCompany();
    this.getAllCountryList();
    this.getHighestQualificationByCompany();
    this.getCurrencyByCompany();
    this.getBankNameByCompany();
    this.getUserByID();
  }

  initilaizeUserForm() {
    this.userForm = this.fb.group({
      aadharNo: ['',Validators.pattern(/^[0-9]{12}$/)],
      address: [''],
      annualCTC: ['', Validators.required],
      band: ['', Validators.required],
      compId: [this.loggedInUserCompanyID],
      companyName: [''],
      contactNo: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      dateOfBirth: [''],
      dateOfJoining: ['', Validators.required],
      dateOfResignation: [''],
      department: ['', Validators.required],
      designation: ['', Validators.required],
      dottedReportingManagerCode: [''],
      dottedReportingManagerName: [null],
      emergencyContactNo: ['',Validators.pattern(/^[0-9]{10}$/)],
      empCode: ['', Validators.required],
      empStatus: ['Active', Validators.required],
      firstName: ['', [Validators.required,Validators.pattern('^[a-zA-Z\\s]+$')]],
      function: ['', Validators.required],
      gender: ['Male', Validators.required],
      grade: ['', Validators.required],
      hodCode: ['', Validators.required],
      hodName: [null, Validators.required],
      id: [null],
      lastName: ['', [Validators.required,Validators.pattern('^[a-zA-Z\\s]+$')]],
      lastWorkingDate: [''],
      maritalStatus: [null],
      monthlyCTC: ['', Validators.required],
      officeLocation: ['', Validators.required],
      officialEmail: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      personalEmail: [null,Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)],
      qualification: [''],
      reportingManagerCode: ['', Validators.required],
      reportingManagerName: [null, Validators.required],
      totalExperience: [null],
      uan: ['',Validators.pattern(/^[0-9]{12}$/)],
      temporaryEmpId:[null]
    });
  }
  initilaizeEmployeeRelatedUserForm() {
    this.employeementRelatedUserForm = this.fb.group({
      empCode: [null, Validators.required],
      employmentCategory: [null, Validators.required],
      employmentType: [null, Validators.required],
      retirementAge: [null],
      empStatus: ['Active', Validators.required],
      dateOfJoining: [null, Validators.required],
      dateOfResignation: [null],
      lastWorkingDate: [null],
      groupName: [null, Validators.required],
      companyName: [null, Validators.required],
      officialEmail: [null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      reportingManagerName: [null, Validators.required],
      reportingManagerCode: [null, Validators.required],
      dottedReportingManagerName: [null],
      dottedReportingManagerCode: [null],
      hodName: [null, Validators.required],
      hodCode: [null, Validators.required],
      band: [null, Validators.required],
      grade: [null, Validators.required],
      designation: [null, Validators.required],
      department: [null, Validators.required],
      subDepartment: [null],
      workLocationState: [null,Validators.required],
      workLocationCity: [null,Validators.required],
      catalystRole: [null],
      designationAtDoj: [null,Validators.required],
      noOfPromotions: [null],
      currentPerformanceScore: [null],
      currentPerformanceRating: [null],
      lastYearPerformanceScore: [null],
      lastYearPerformanceRating: [null],
      yearBeforeLastYearPerformanceScore: [null],
      yearBeforeLastYearPerformanceRating: [null],
      temporaryEmpId: [null],
    });
  }
  initilaizeGeneralInformationUserForm() {
    this.generalInformationUserForm = this.fb.group({
      salutation: [null, Validators.required],
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      gender: [null, Validators.required],
      country: ['India', Validators.required],
      address: [null, Validators.required],
      permanentAddress: [null],
      maritalStatus: [null],
      dateOfMarriage: [null],
      dateOfBirth: [null, Validators.required],
      age: [null],
      personalEmail: [null],
      aadharNo: [null, [Validators.required, Validators.pattern(/^[0-9]{12}$/)]],
      panNo: [null, [Validators.required, Validators.pattern(/^[A-Za-z0-9]{10}$/)]],
      uan: [null, Validators.pattern(/^[0-9]{12}$/)],
      contactNo: [null, [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      totalExperience: [null],
      emergencyContactNo: [null],
      bloodGroup: [null],
      fathersName: [null],
      mothersName: [null],
      spouseName: [null],
      noOfChildren: [null],
      isRelativeWorking: [false],
      workingRelativeName: [null],
      workingRelativeRelation: [null],
      id: [null],
      isReplacement: [true],
      replacementId: [this.getUserId],
    });
  }
  initilaizeEducationRelatedInformationUserForm() {
    this.educationRelatedInformationUserForm = this.fb.group({
      highestEducationQualification: [null],
      highestEducationInstitute: [null],
      highestEducationYearOfPassing: [null],
      highestEducationMarks: [null],
      highestEducationQualification2: [null],
      highestEducationInstitute2: [null],
      highestEducationYearOfPassing2: [null],
      highestEducationMarks2: [null],
      highestEducationQualification3: [null],
      highestEducationInstitute3: [null],
      highestEducationYearOfPassing3: [null],
      highestEducationMarks3: [null],
      highestProfessionalQualification: [null],
      highestProfessionalInstitute: [null],
      highestProfessionalYearOfPassing: [null],
      highestProfessionalMarks: [null],
    });
  }
  initilaizeSalaryRelatedInformationUserForm() {
    this.salaryRelatedInformationUserForm = this.fb.group({
      currency: ['INR'],
      salaryStatus: [null, Validators.required],
      bankName: [null, Validators.required],
      bankBranchAddress: [null, Validators.required],
      bankAccount: [null, Validators.required],
      ifscCode: [null, Validators.required],
      basicSalaryPm: [null, Validators.required],
      daPm: [null],
      hraPm: [null,],
      otherAllowancePm: [null,],
      ltaPm: [null,],
      medicalAllowancePm: [null,],
      washingAllowancePm: [null,],
      specialAllowancePm: [null,],
      fuelAllowancePm: [null,],
      entertainmentAllowancePm: [null,],
      educationAllowancePm: [null,],
      booksAllowancePm: [null,],
      statutoryBonusPm: [null,],
      anyOtherAllowancePm: [null,],
      grossSalaryPm: [null, Validators.required],
      employeePfPm: [null,],
      employerPfPm: [null],
      ptPm: [null],
      lwfPm: [null],
      esicPm: [null],
      otherRetiralPm: [null],
      totalRetiralPm: [null, Validators.required],
      monthlyCTC: [null, Validators.required],
      annualCTC: [null, Validators.required],
      processOfVp: [null, Validators.required],
      annualVariablePayBudget: [null],
      annualTotalCtc: [null, Validators.required],
      incrementOn: [null, Validators.required],
    });
  }
  initilaizePriorEmploymentRelatedInformationUserForm() {
    this.priorEmploymentRelatedInformationUserForm = this.fb.group({
      lastOrganisationName: [null],
      lastOrganisationDoj: [null],
      lastOrganisationLwd: [null],
      lastOrganisationDepartment: [null],
      lastOrganisationDesignation: [null],
      lastToLastOrganisationName: [null],
      lastToLastOrganisationDoj: [null],
      lastToLastOrganisationLwd: [null],
      lastToLastOrganisationDepartment: [null],
      lastToLastOrganisationDesignation: [null],
      otherOrganisationName: [null],
      otherOrganisationDoj: [null],
      otherOrganisationLwd: [null],
      otherOrganisationDepartment: [null],
      otherOrganisationDesignation: [null],
    });
  }
  getUserByID(){
    this.httpService.callGetService(this.config.getEmployeeById + this.getUserId).subscribe((data: any) => {
      this.loggedInUserCompanyID  = data?.data?.companyId;
      this.getAllEmployeeDropdownByCompanyID();
      setTimeout(() => {
        this.userForm.controls['band'].setValue(data?.data?.band);
        this.userForm.controls['compId'].setValue(data?.data?.companyId);
        this.userForm.controls['companyName'].setValue(data?.data?.companyName);
        this.userForm.controls['dottedReportingManagerCode'].setValue(data?.data?.dottedReportingManagerCode);
        this.userForm.controls['dottedReportingManagerName'].setValue(data?.data?.dottedReportingManager?.id);
        this.userForm.controls['grade'].setValue(data?.data?.grade);
        this.userForm.controls['function'].setValue(data?.data?.empFunction);
        this.userForm.controls['hodCode'].setValue(data?.data?.hodCode);
        this.userForm.controls['hodName'].setValue(data?.data?.hod?.id);
        this.userForm.controls['reportingManagerCode'].setValue(data?.data?.reportingManagerCode);
        this.userForm.controls['reportingManagerName'].setValue(data?.data?.reportingManager?.id);
      },
      1000);
    })
  }
  getAllEmployeeDropdownByCompanyID() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
    }
    this.httpService.callPostService(this.config.getAllEmployeeDropdownByCompanyID, request)
      .subscribe((data: any) => {
        this.getAllEmployeeofCompany = [];
        this.assignReporteesDropdown = [];
        data?.data?.users.forEach((ele: any) => {
          if(this.getUserId!=ele.id){
            let obj = {
              id: ele.id,
              name: ele.firstName + ' ' + ele.lastName,
              empCode: ele.empCode
            }
            this.assignReporteesDropdown.push(obj);
          }
        });
        data?.data?.users.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName,
            empCode: ele.empCode
          }
          this.getAllEmployeeofCompany.push(obj);
        });
      }, (error: any) => {
      }, () => { });
  }
  closeDialog() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to leave this page?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close(this.isReplaceEmployeeFilled);
      }
    });
  }
  onSelectionOfHod() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeementRelatedUserForm.controls['hodName'].value);
    this.employeementRelatedUserForm.controls['hodCode'].setValue(data?.empCode);
  }
  onSelectionOfManager() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeementRelatedUserForm.controls['reportingManagerName'].value);
    this.employeementRelatedUserForm.controls['reportingManagerCode'].setValue(data?.empCode);
  }
  onSelectionOfDottedManager() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeementRelatedUserForm.controls['dottedReportingManagerName'].value);
    this.employeementRelatedUserForm.controls['dottedReportingManagerCode'].setValue(data?.empCode);
  }
  addSubmitForm: boolean = false;

  replaceEmployee() {
    
    this.addSubmitForm = true;
    this.employeementRelatedUserForm.markAllAsTouched();
    this.generalInformationUserForm.markAllAsTouched();
    this.educationRelatedInformationUserForm.markAllAsTouched();
    this.salaryRelatedInformationUserForm.markAllAsTouched();
    this.priorEmploymentRelatedInformationUserForm.markAllAsTouched();

    if(this.employeementRelatedUserForm.value.groupName?.label){
      this.employeementRelatedUserForm.controls['groupName'].setValue(this.employeementRelatedUserForm.value.groupName?.label);
    }
    if(this.employeementRelatedUserForm.value.companyName?.label){
      this.employeementRelatedUserForm.controls['companyName'].setValue(this.employeementRelatedUserForm.value.companyName?.label);
    }
    if(this.employeementRelatedUserForm.value.band?.label){
      this.employeementRelatedUserForm.controls['band'].setValue(this.employeementRelatedUserForm.value.band?.label);
    }
    if(this.employeementRelatedUserForm.value.grade?.label){
      this.employeementRelatedUserForm.controls['grade'].setValue(this.employeementRelatedUserForm.value.grade?.label);
    }
    if(this.employeementRelatedUserForm.value.designation?.label){
      this.employeementRelatedUserForm.controls['designation'].setValue(this.employeementRelatedUserForm.value.designation?.label);
    }
    if(this.employeementRelatedUserForm.value.department?.label){
      this.employeementRelatedUserForm.controls['department'].setValue(this.employeementRelatedUserForm.value.department?.label);
    }
    if(this.employeementRelatedUserForm.value.subDepartment?.label){
      this.employeementRelatedUserForm.controls['subDepartment'].setValue(this.employeementRelatedUserForm.value.subDepartment?.label);
    }
    if(this.employeementRelatedUserForm.value.designationAtDoj?.label){
      this.employeementRelatedUserForm.controls['designationAtDoj'].setValue(this.employeementRelatedUserForm.value.designationAtDoj?.label);
    }
    if(this.employeementRelatedUserForm.value.currentPerformanceRating?.label){
      this.employeementRelatedUserForm.controls['currentPerformanceRating'].setValue(this.employeementRelatedUserForm.value.currentPerformanceRating?.label);
    }
    if(this.employeementRelatedUserForm.value.lastYearPerformanceRating?.label){
      this.employeementRelatedUserForm.controls['lastYearPerformanceRating'].setValue(this.employeementRelatedUserForm.value.lastYearPerformanceRating?.label);
    }
    if(this.employeementRelatedUserForm.value.yearBeforeLastYearPerformanceRating?.label){
      this.employeementRelatedUserForm.controls['yearBeforeLastYearPerformanceRating'].setValue(this.employeementRelatedUserForm.value.yearBeforeLastYearPerformanceRating?.label);
    }
    if(this.educationRelatedInformationUserForm.value.highestEducationQualification?.label){
      this.educationRelatedInformationUserForm.controls['highestEducationQualification'].setValue(this.educationRelatedInformationUserForm.value.highestEducationQualification?.label);
    }
    if(this.salaryRelatedInformationUserForm.value.currency?.label){
      this.salaryRelatedInformationUserForm.controls['currency'].setValue(this.salaryRelatedInformationUserForm.value.currency?.label);
    }
    if(this.salaryRelatedInformationUserForm.value.bankName?.label){
      this.salaryRelatedInformationUserForm.controls['bankName'].setValue(this.salaryRelatedInformationUserForm.value.bankName?.label);
    }
    this.employeementRelatedUserForm.controls['officialEmail'].setValue(this.employeementRelatedUserForm.value.officialEmail?.trim());
    this.generalInformationUserForm.controls['personalEmail'].setValue(this.generalInformationUserForm.value.personalEmail?.trim());
    this.generalInformationUserForm.controls['firstName'].setValue(this.generalInformationUserForm.value.firstName?.trim());
    this.generalInformationUserForm.controls['lastName'].setValue(this.generalInformationUserForm.value.lastName?.trim());
    this.generalInformationUserForm.controls['address'].setValue(this.generalInformationUserForm.value.address?.trim());
    this.employeementRelatedUserForm.controls['companyName'].setValue(this.employeementRelatedUserForm.value.companyName?.trim());
    this.employeementRelatedUserForm.controls['grade'].setValue(this.employeementRelatedUserForm.value.grade?.trim());
    this.employeementRelatedUserForm.controls['designation'].setValue(this.employeementRelatedUserForm.value.designation?.trim());
    this.employeementRelatedUserForm.controls['department'].setValue(this.employeementRelatedUserForm.value.department?.trim());
    this.employeementRelatedUserForm.controls['workLocationCity'].setValue(this.employeementRelatedUserForm.value.workLocationCity?.trim());
    // this.userForm.controls['officialEmail'].setValue(this.userForm.value.officialEmail?.trim());
    // this.userForm.controls['personalEmail'].setValue(this.userForm.value.personalEmail?.trim());
    // this.userForm.controls['firstName'].setValue(this.userForm.value.firstName?.trim());
    // this.userForm.controls['lastName'].setValue(this.userForm.value.lastName?.trim());
    // this.userForm.controls['companyName'].setValue(this.userForm.value.companyName?.trim());
    // this.userForm.controls['grade'].setValue(this.userForm.value.grade?.trim());
    // this.userForm.controls['function'].setValue(this.userForm.value.function?.trim());
    // this.userForm.controls['designation'].setValue(this.userForm.value.designation?.trim());
    // this.userForm.controls['department'].setValue(this.userForm.value.department?.trim());
    // this.userForm.controls['officeLocation'].setValue(this.userForm.value.officeLocation?.trim());
    // this.userForm.controls['qualification'].setValue(this.userForm.value.qualification?.trim());
    
    if (this.employeementRelatedUserForm.valid && this.generalInformationUserForm.valid &&
      this.educationRelatedInformationUserForm.valid && this.salaryRelatedInformationUserForm.valid && 
      this.priorEmploymentRelatedInformationUserForm.valid && !this.showErrorMsgOfExistUAN && 
      !this.showErrorMsgOfExistPAN && !this.showErrorMsgOfExistAddharNo && !this.showErrorMsgOfExistAccountNo && 
      !this.showErrorMsgOfExistEmail) {
      this.addSubmitForm = false;
      const request = {
        aadharNo: this.generalInformationUserForm.value.aadharNo,
        address: this.generalInformationUserForm.value.address,
        age: this.generalInformationUserForm.value.age,
        annualCTC: this.salaryRelatedInformationUserForm.value.annualCTC,
        annualTotalCtc: this.salaryRelatedInformationUserForm.value.annualTotalCtc,
        annualVariablePayBudget: this.salaryRelatedInformationUserForm.value.annualVariablePayBudget,
        anyOtherAllowancePm: this.salaryRelatedInformationUserForm.value.anyOtherAllowancePm,
        band: this.employeementRelatedUserForm.value.band,
        bankAccount: this.salaryRelatedInformationUserForm.value.bankAccount,
        bankBranchAddress: this.salaryRelatedInformationUserForm.value.bankBranchAddress,
        bankName: this.salaryRelatedInformationUserForm.value.bankName,
        basicSalaryPm: this.salaryRelatedInformationUserForm.value.basicSalaryPm,
        bloodGroup: this.generalInformationUserForm.value.bloodGroup,
        booksAllowancePm: this.salaryRelatedInformationUserForm.value.booksAllowancePm,
        catalystRole: this.employeementRelatedUserForm.value.catalystRole,
        compId: this.loggedInUserCompanyID,
        companyName: this.employeementRelatedUserForm.value.companyName,
        contactNo: this.generalInformationUserForm.value.contactNo,
        country: this.generalInformationUserForm.value.country,
        currency: this.salaryRelatedInformationUserForm.value.currency,
        currentPerformanceRating: this.employeementRelatedUserForm.value.currentPerformanceRating,
        currentPerformanceScore: this.employeementRelatedUserForm.value.currentPerformanceScore,
        customValues: this.customFieldObject,
        daPm: this.salaryRelatedInformationUserForm.value.daPm,
        dateOfBirth: this.datePipe.transform(this.generalInformationUserForm.value.dateOfBirth, "yyyy-MM-dd"),
        dateOfJoining: this.datePipe.transform(this.employeementRelatedUserForm.value.dateOfJoining, "yyyy-MM-dd"),
        dateOfMarriage: this.datePipe.transform(this.generalInformationUserForm.value.dateOfMarriage, "yyyy-MM-dd"),
        dateOfResignation: this.datePipe.transform(this.employeementRelatedUserForm.value.dateOfResignation, "yyyy-MM-dd"),
        department: this.employeementRelatedUserForm.value.department,
        designation: this.employeementRelatedUserForm.value.designation,
        designationAtDoj: this.employeementRelatedUserForm.value.designationAtDoj,
        dottedReportingManagerCode: this.employeementRelatedUserForm.value.dottedReportingManagerCode,
        dottedReportingManagerName: this.employeementRelatedUserForm.value.dottedReportingManagerName,
        educationAllowancePm: this.salaryRelatedInformationUserForm.value.educationAllowancePm,
        emergencyContactNo: this.generalInformationUserForm.value.emergencyContactNo,
        empCode: this.employeementRelatedUserForm.value.empCode,
        empStatus: this.employeementRelatedUserForm.value.empStatus,
        employeePfPm: this.salaryRelatedInformationUserForm.value.employeePfPm,
        employerPfPm: this.salaryRelatedInformationUserForm.value.employerPfPm,
        employmentCategory: this.employeementRelatedUserForm.value.employmentCategory,
        employmentType: this.employeementRelatedUserForm.value.employmentType,
        entertainmentAllowancePm: this.salaryRelatedInformationUserForm.value.entertainmentAllowancePm,
        esicPm: this.salaryRelatedInformationUserForm.value.esicPm,
        fathersName: this.generalInformationUserForm.value.fathersName,
        firstName: this.generalInformationUserForm.value.firstName,
        fuelAllowancePm: this.salaryRelatedInformationUserForm.value.fuelAllowancePm,
        function: null,
        gender: this.generalInformationUserForm.value.gender,
        grade: this.employeementRelatedUserForm.value.grade,
        grossSalaryPm: this.salaryRelatedInformationUserForm.value.grossSalaryPm,
        groupName: this.employeementRelatedUserForm.value.groupName,
        highestEducationInstitute: this.educationRelatedInformationUserForm.value.highestEducationInstitute,
        highestEducationInstitute2: this.educationRelatedInformationUserForm.value.highestEducationInstitute2,
        highestEducationInstitute3: this.educationRelatedInformationUserForm.value.highestEducationInstitute3,
        highestEducationMarks: this.educationRelatedInformationUserForm.value.highestEducationMarks,
        highestEducationMarks2: this.educationRelatedInformationUserForm.value.highestEducationMarks2,
        highestEducationMarks3: this.educationRelatedInformationUserForm.value.highestEducationMarks3,
        highestEducationQualification: this.educationRelatedInformationUserForm.value.highestEducationQualification,
        highestEducationQualification2: this.educationRelatedInformationUserForm.value.highestEducationQualification2,
        highestEducationQualification3: this.educationRelatedInformationUserForm.value.highestEducationQualification3,
        highestEducationYearOfPassing: this.educationRelatedInformationUserForm.value.highestEducationYearOfPassing,
        highestEducationYearOfPassing2: this.educationRelatedInformationUserForm.value.highestEducationYearOfPassing2,
        highestEducationYearOfPassing3: this.educationRelatedInformationUserForm.value.highestEducationYearOfPassing3,
        highestProfessionalInstitute: this.educationRelatedInformationUserForm.value.highestProfessionalInstitute,
        highestProfessionalMarks: this.educationRelatedInformationUserForm.value.highestProfessionalMarks,
        highestProfessionalQualification: this.educationRelatedInformationUserForm.value.highestProfessionalQualification,
        highestProfessionalYearOfPassing: this.educationRelatedInformationUserForm.value.highestProfessionalYearOfPassing,
        hodCode: this.employeementRelatedUserForm.value.hodCode,
        hodName: this.employeementRelatedUserForm.value.hodName,
        hraPm: this.salaryRelatedInformationUserForm.value.hraPm,
        id: this.generalInformationUserForm.value.id,
        ifscCode: this.salaryRelatedInformationUserForm.value.ifscCode,
        incrementOn: this.salaryRelatedInformationUserForm.value.incrementOn,
        isRelativeWorking: this.generalInformationUserForm.value.isRelativeWorking,
        isReplacement: this.generalInformationUserForm.value.isReplacement,
        isVacant: false,
        lastName: this.generalInformationUserForm.value.lastName,
        lastOrganisationDepartment: this.priorEmploymentRelatedInformationUserForm.value.lastOrganisationDepartment,
        lastOrganisationDesignation: this.priorEmploymentRelatedInformationUserForm.value.lastOrganisationDesignation,
        lastOrganisationDoj: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.lastOrganisationDoj, "yyyy-MM-dd"),
        lastOrganisationLwd: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.lastOrganisationLwd, "yyyy-MM-dd"),
        lastOrganisationName: this.priorEmploymentRelatedInformationUserForm.value.lastOrganisationName,
        lastToLastOrganisationDepartment: this.priorEmploymentRelatedInformationUserForm.value.lastToLastOrganisationDepartment,
        lastToLastOrganisationDesignation: this.priorEmploymentRelatedInformationUserForm.value.lastToLastOrganisationDesignation,
        lastToLastOrganisationDoj: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.lastToLastOrganisationDoj, "yyyy-MM-dd"),
        lastToLastOrganisationLwd: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.lastToLastOrganisationLwd, "yyyy-MM-dd"),
        lastToLastOrganisationName: this.priorEmploymentRelatedInformationUserForm.value.lastToLastOrganisationName,
        lastWorkingDate: this.datePipe.transform(this.employeementRelatedUserForm.value.lastWorkingDate, "yyyy-MM-dd"),
        lastYearPerformanceRating: this.employeementRelatedUserForm.value.lastYearPerformanceRating,
        lastYearPerformanceScore: this.employeementRelatedUserForm.value.lastYearPerformanceScore,
        ltaPm: this.salaryRelatedInformationUserForm.value.ltaPm,
        lwfPm: this.salaryRelatedInformationUserForm.value.lwfPm,
        maritalStatus: this.generalInformationUserForm.value.maritalStatus,
        medicalAllowancePm: this.salaryRelatedInformationUserForm.value.medicalAllowancePm,
        monthlyCTC: this.salaryRelatedInformationUserForm.value.monthlyCTC,
        mothersName: this.generalInformationUserForm.value.mothersName,
        noOfChildren: this.generalInformationUserForm.value.noOfChildren,
        noOfPromotions: this.employeementRelatedUserForm.value.noOfPromotions,
        officeLocation: this.employeementRelatedUserForm.value.workLocationCity,
        officialEmail: this.employeementRelatedUserForm.value.officialEmail,
        otherAllowancePm: this.salaryRelatedInformationUserForm.value.otherAllowancePm,
        otherOrganisationDepartment: this.priorEmploymentRelatedInformationUserForm.value.otherOrganisationDepartment,
        otherOrganisationDesignation: this.priorEmploymentRelatedInformationUserForm.value.otherOrganisationDesignation,
        otherOrganisationDoj: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.otherOrganisationDoj, "yyyy-MM-dd"),
        otherOrganisationLwd: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.otherOrganisationLwd, "yyyy-MM-dd"),
        otherOrganisationName: this.priorEmploymentRelatedInformationUserForm.value.otherOrganisationName,
        otherRetiralPm: this.salaryRelatedInformationUserForm.value.otherRetiralPm,
        panNo: this.generalInformationUserForm.value.panNo,
        permanentAddress: this.generalInformationUserForm.value.permanentAddress,
        personalEmail: this.generalInformationUserForm.value.personalEmail,
        processOfVp: this.salaryRelatedInformationUserForm.value.processOfVp,
        ptPm: this.salaryRelatedInformationUserForm.value.ptPm,
        qualification: null,
        replacementId: this.generalInformationUserForm.value.replacementId,
        reportingManagerCode: this.employeementRelatedUserForm.value.reportingManagerCode,
        reportingManagerName: this.employeementRelatedUserForm.value.reportingManagerName,
        retirementAge: this.employeementRelatedUserForm.value.retirementAge,
        salaryStatus: this.salaryRelatedInformationUserForm.value.salaryStatus,
        salutation: this.generalInformationUserForm.value.salutation,
        specialAllowancePm: this.salaryRelatedInformationUserForm.value.specialAllowancePm,
        spouseName: this.generalInformationUserForm.value.spouseName,
        statutoryBonusPm: this.salaryRelatedInformationUserForm.value.statutoryBonusPm,
        subDepartment: this.employeementRelatedUserForm.value.subDepartment,
        temporaryEmpId: this.employeementRelatedUserForm.value.temporaryEmpId,
        totalExperience: this.generalInformationUserForm.value.totalExperience,
        totalRetiralPm: this.salaryRelatedInformationUserForm.value.totalRetiralPm,
        uan: this.generalInformationUserForm.value.uan,
        washingAllowancePm: this.salaryRelatedInformationUserForm.value.washingAllowancePm,
        workLocationCity: this.employeementRelatedUserForm.value.workLocationCity,
        workLocationState: this.employeementRelatedUserForm.value.workLocationState,
        workingRelativeName: this.generalInformationUserForm.value.workingRelativeName,
        workingRelativeRelation: this.generalInformationUserForm.value.workingRelativeRelation,
        yearBeforeLastYearPerformanceRating: this.employeementRelatedUserForm.value.yearBeforeLastYearPerformanceRating,
        yearBeforeLastYearPerformanceScore: this.employeementRelatedUserForm.value.yearBeforeLastYearPerformanceScore

      }
      this.httpService.callPostService(this.config.replaceEmployee, request)
      .subscribe((data: any) => {
        this.loader.dismissLoader();
        
        if(!data?.success){
          this.isReplaceEmployeeFilled = false;
          const successdialogRef = this.dialog.open(ConfirmationPopupComponent,{
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.data,
              btn2: 'OK',
              btn2BgColor: '#F6921E',
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: false
            },
          });
          successdialogRef.afterClosed().subscribe(result => {
          });
        }else{
        this.isReplaceEmployeeFilled = true;
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent,{
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: data.data,
            btn2: 'OK',
            btn2BgColor: '#F6921E',
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        successdialogRef.afterClosed().subscribe(result => {
          this.dialogRef.close(this.isReplaceEmployeeFilled);
        });
      }
      }, (error: any) => {
      }, () => { });
    }
  }
  calculateAgeFromDOB() {
    const dob = new Date(this.generalInformationUserForm.value.dateOfBirth)
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // Adjust age if the current date is before the birth date in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    this.generalInformationUserForm.controls['age'].setValue(age);
  }

  getGroupNameByCompany() {
    this.httpService.callGetService(this.config.getGroupNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfGroupNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfGroupNameOfComp.push(obj);
      });
      this.getListOfGroupNameOfComp = this.getListOfGroupNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getCompanyNameByCompany() {
    this.httpService.callGetService(this.config.getCompanyNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfCompanyNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfCompanyNameOfComp.push(obj);
      });
      this.getListOfCompanyNameOfComp = this.getListOfCompanyNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getBandsByCompany() {
    this.httpService.callGetService(this.config.getBandsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfBandNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfBandNameOfComp.push(obj);
      });
      this.getListOfBandNameOfComp = this.getListOfBandNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getGradeByCompany() {
    this.httpService.callGetService(this.config.getGradesByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfGradeNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfGradeNameOfComp.push(obj);
      });
      this.getListOfGradeNameOfComp = this.getListOfGradeNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getDesignationsByCompany() {
    this.httpService.callGetService(this.config.getDesignationsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDesignationsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDesignationsOfComp.push(obj);
      });
      this.getListOfDesignationsOfComp = this.getListOfDesignationsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getDepartmentsByCompany() {
    this.httpService.callGetService(this.config.getDepartmentsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDepartmentsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDepartmentsOfComp.push(obj);
      });
      this.getListOfDepartmentsOfComp = this.getListOfDepartmentsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getSubDepartmentByCompany() {
    this.httpService.callGetService(this.config.getSubDepartmentByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfSubDepartmentsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfSubDepartmentsOfComp.push(obj);
      });
      this.getListOfSubDepartmentsOfComp = this.getListOfSubDepartmentsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getDesignationsAtDOJByCompany() {
    this.httpService.callGetService(this.config.getDesignationsAtDOJByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDesignationsAtDOJOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDesignationsAtDOJOfComp.push(obj);
      });
      this.getListOfDesignationsAtDOJOfComp = this.getListOfDesignationsAtDOJOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getCurrentRatingByCompany() {
    this.httpService.callGetService(this.config.getCurrentRatingByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfCurrentRatingOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfCurrentRatingOfComp.push(obj);
      });
      this.getListOfCurrentRatingOfComp = this.getListOfCurrentRatingOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getLastYearRatingByCompany() {
    this.httpService.callGetService(this.config.getLastYearRatingByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfLastYearRatingOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfLastYearRatingOfComp.push(obj);
      });
      this.getListOfLastYearRatingOfComp = this.getListOfLastYearRatingOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getLastToLastYearRatingByCompany() {
    this.httpService.callGetService(this.config.getLastToLastYearRatingByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfLastToLastYearRatingOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfLastToLastYearRatingOfComp.push(obj);
      });
      this.getListOfLastToLastYearRatingOfComp = this.getListOfLastToLastYearRatingOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getAllCountryList() {
    this.httpService.callGetService("https://restcountries.com/v3.1/all").subscribe((data: any) => {
      this.getCountryList = [];
      var getCountryList = data.map((country: { name: { common: any; }; }) => country.name.common);
      getCountryList?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getCountryList.push(obj);
      });
      this.getCountryList = this.getCountryList.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getCurrencyByCompany() {
    this.httpService.callGetService(this.config.getCurrencyByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getCurrencyList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getCurrencyList.push(obj);
      });
      this.getCurrencyList = this.getCurrencyList.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getBankNameByCompany() {
    this.httpService.callGetService(this.config.getBankNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getBankNameList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getBankNameList.push(obj);
      });
      this.getBankNameList = this.getBankNameList.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getHighestQualificationByCompany() {
    this.httpService.callGetService(this.config.getHighestQualificationByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfHighestQualificationOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfHighestQualificationOfComp.push(obj);
      });
      this.getListOfHighestQualificationOfComp = this.getListOfHighestQualificationOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }

  states: string[] = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
    'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya',
    'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim',
    'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand',
    'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu', 'Lakshadweep',
    'Delhi', 'Puducherry', 'Ladakh', 'Jammu and Kashmir'
  ];
  getAllCustomFieldsList() {
    this.httpService.callGetService(this.config.getAllCustomFieldsList).subscribe((data: any) => {
      this.customFieldObject = [];
      data?.objectData?.setResponse?.forEach((ele: any) => {
        let obj = {
          fieldId: ele?.id,
          fieldName: ele.fieldName,
          fieldValue: null,
          id: null
        }
        this.customFieldObject.push(obj);
      });
    })
  }
  showErrorMsgOfExistUAN: boolean = false;
  showErrorMsgOfExistPAN: boolean = false;
  showErrorMsgOfExistAddharNo: boolean = false;
  showErrorMsgOfExistAccountNo: boolean = false;
  showErrorMsgOfExistEmail: boolean = false;
  checkUanNo() {
    if(this.generalInformationUserForm.value.uan.length!=12){
      return
    }
    if (this.generalInformationUserForm.value.uan != null) {
      const request = {
        "field": this.generalInformationUserForm.value.uan
      }
      this.httpService.callPostService(this.config.checkUanNo, request)
        .subscribe((data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistUAN = true;
          } else {
            this.showErrorMsgOfExistUAN = false;
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  checkAccountNo() {
    if (this.generalInformationUserForm.value.bankAccount != null) {
      const request = {
        "field": this.salaryRelatedInformationUserForm.value.bankAccount
      }
      this.httpService.callPostService(this.config.checkAccountNo, request)
        .subscribe((data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistAccountNo = true;
          } else {
            this.showErrorMsgOfExistAccountNo = false;
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  checkPanNo() {
    if(this.generalInformationUserForm.value.panNo.length!=12){
      return
    }
    if (this.generalInformationUserForm.value.panNo != null) {
      const request = {
        "field": this.generalInformationUserForm.value.panNo
      }
      this.httpService.callPostService(this.config.checkPanNo, request)
        .subscribe((data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistPAN = true;
          } else {
            this.showErrorMsgOfExistPAN = false;
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  checkAadharNo() {
    if(this.generalInformationUserForm.value.aadharNo.length!=12){
      return
    }
    if (this.generalInformationUserForm.value.aadharNo != null) {
      const request = {
        "field": this.generalInformationUserForm.value.aadharNo,
      }
      this.httpService.callPostService(this.config.checkAadharNo, request)
        .subscribe((data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistAddharNo = true;
          } else {
            this.showErrorMsgOfExistAddharNo = false;
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  checkEmailInTheSystem() {
    if(this.employeementRelatedUserForm.value.officialEmail==""){
      this.employeementRelatedUserForm.controls['officialEmail'].setValue(null);
    }
    if (this.employeementRelatedUserForm.value.officialEmail != null) {
      const request = {
        "email": this.employeementRelatedUserForm.value.officialEmail,
        "companyId":this.loggedInUserCompanyID
      }
      this.httpService.callPostService(this.config.checkEmailInTheSystem, request)
        .subscribe((data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistEmail = true;
          } else {
            this.showErrorMsgOfExistEmail = false;
          }
        }, (error: any) => {
        }, () => { });
    }else{
      this.showErrorMsgOfExistEmail = false;
    }
  }
  caluclateGrossSalary(){
    // this.salaryRelatedInformationUserForm.controls['basicSalaryPm'].setValue(
    //   this.currencyPipe.transform(this.salaryRelatedInformationUserForm.value.basicSalaryPm,'INR','', '1.2-2'));
    // this.salaryRelatedInformationUserForm.controls['daPm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.daPm));
    // this.salaryRelatedInformationUserForm.controls['hraPm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.hraPm));
    // this.salaryRelatedInformationUserForm.controls['otherAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.otherAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['ltaPm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.ltaPm));
    // this.salaryRelatedInformationUserForm.controls['medicalAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.medicalAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['washingAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.washingAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['specialAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.specialAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['fuelAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.fuelAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['entertainmentAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.entertainmentAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['educationAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.educationAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['booksAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.booksAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['statutoryBonusPm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.statutoryBonusPm));
    // this.salaryRelatedInformationUserForm.controls['anyOtherAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.anyOtherAllowancePm));

    // const basicSalaryPm = Number(this.salaryRelatedInformationUserForm.value.basicSalaryPm);
    // const daPm =  Number(this.salaryRelatedInformationUserForm.value.daPm);
    // const hraPm =  Number(this.salaryRelatedInformationUserForm.value.hraPm);
    // const otherAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.otherAllowancePm);
    // const ltaPm =  Number(this.salaryRelatedInformationUserForm.value.ltaPm);
    // const medicalAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.medicalAllowancePm);
    // const washingAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.washingAllowancePm);
    // const specialAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.specialAllowancePm);
    // const fuelAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.fuelAllowancePm);
    // const entertainmentAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.entertainmentAllowancePm);
    // const educationAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.educationAllowancePm);
    // const booksAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.booksAllowancePm);
    // const statutoryBonusPm =  Number(this.salaryRelatedInformationUserForm.value.statutoryBonusPm);
    // const anyOtherAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.anyOtherAllowancePm);

    // this.salaryRelatedInformationUserForm.controls['grossSalaryPm'].setValue(basicSalaryPm+daPm+hraPm+otherAllowancePm+
    //   ltaPm+medicalAllowancePm+washingAllowancePm+specialAllowancePm+fuelAllowancePm+entertainmentAllowancePm+educationAllowancePm
    //   +booksAllowancePm+statutoryBonusPm+anyOtherAllowancePm);
    // this.salaryRelatedInformationUserForm.controls['grossSalaryPm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.grossSalaryPm));
  }
  onInputChange(value: any) {
    // const numericValue = value?.replace(/,/g, '');
    // this.salaryRelatedInformationUserForm.controls['basicSalaryPm'].setValue(numericValue, { emitEvent: false });
  }
  caluclateAnnualTotalCTC(){
    // const annualCTC = Number(this.salaryRelatedInformationUserForm.value.annualCTC);
    // const annualVariablePayBudget = Number(this.salaryRelatedInformationUserForm.value.annualVariablePayBudget);
    // this.salaryRelatedInformationUserForm.controls['annualTotalCtc'].setValue(annualCTC + annualVariablePayBudget);
  }
  checkNumerIsPositive(event:any,fomrControlName:any){
    const inputElement = event.target as HTMLInputElement;
    var value = inputElement.value;
    if(Number(value) < 0){
      this.salaryRelatedInformationUserForm.controls[fomrControlName].setValue(null);
    }
  }
  checkNumerIsPositiveemployeementRelatedUserForm(event:any,fomrControlName:any){
    const inputElement = event.target as HTMLInputElement;
    var value = inputElement.value;
    if(Number(value) < 0){
      this.employeementRelatedUserForm.controls[fomrControlName].setValue(null);
    }
  }
  checkNumerIsPositivgeneralInformationUserForm(event:any,fomrControlName:any){
    const inputElement = event.target as HTMLInputElement;
    var value = inputElement.value;
    if(Number(value) < 0){
      this.generalInformationUserForm.controls[fomrControlName].setValue(null);
    }
  }
  checkNumerIsPositiveeducationRelatedInformationUserForm(event:any,fomrControlName:any){
    const inputElement = event.target as HTMLInputElement;
    var value = inputElement.value;
    if(Number(value) < 0){
      this.educationRelatedInformationUserForm.controls[fomrControlName].setValue(null);
    }
  }
}
